export const userInfoTableConfig = {
  searchUrl: "/front/oms/supplier/User/queryPage", // 搜索接口
  searchMethod: "POST", // 接口请求方式
  needPagination: true, // 是否需要分页
  fluidHeight: true, // 流体高度
  showOrdinal: false, // 是否显示序号,
  count: "total",
  resultListName: "records",
  params: [
    {
      prop: "ssoSupplierUserName",
      label: "姓名",
    },
    {
      prop: "username",
      label: "账号",
      width: "160px",
    },
    {
      prop: "userTypeStr",
      label: "角色",
      width: "100px",
    },
    {
      prop: "userAbilityList",
      label: "行业/产品",
      isSlot: true,
    },
    {
      prop: "registerTime",
      label: "加入时间",
      width: "160px",
    },
    {
      prop: "onOrOffStr",
      label: "状态",
      width: "100px",
      isSlot:true
    },

  ],
  extra: {},
};

export const attrTableConfig = {
  searchUrl: "/front/oms/supplierAbilityApply/queryPage", // 搜索接口
  searchMethod: "POST", // 接口请求方式
  needPagination: true, // 是否需要分页
  fluidHeight: true, // 流体高度
  showOrdinal: false, // 是否显示序号,
  count: "total",
  resultListName: "records",
  params: [
    {
      prop: "supplierAbilityApplyNo",
      label: "申请单号",
      isSlot: true,
      width: "130px",
    },
    {
      prop: "applyUserName",
      label: "申请人账号",
      width: "120px",
    },
    {
      prop: "createUserName",
      label: "申请人名称",
      width: "100px",
    },
    {
      prop: "industryStr",
      label: "申请行业",
      width: "100px",
    },
    {
      prop: "industryFiles",
      label: "行业证明材料",
      isSlot: true,
      showOverflowTooltip: true,
    },
    {
      prop: "abilityList",
      label: "申请属性标签",
      isSlot: true,
    },
    {
      prop: "proofFiles",
      label: "属性证明材料",
      isSlot: true,
      showOverflowTooltip: true,
    },
    {
      prop: "remark",
      label: "申请备注",
      showOverflowTooltip: true,
    },

    {
      prop: "createTime",
      label: "申请时间",
      width: "100px",
    },

    {
      prop: "ssoSupplierAbilityApplyStatusStr",
      label: "状态",
      width: "100px",
    },
  ],
  extra: {},
};

export const accountTableConfig = {
  searchUrl: "/front/oms/supplier/UserApply/queryPage", // 搜索接口
  searchMethod: "POST", // 接口请求方式
  needPagination: true, // 是否需要分页
  fluidHeight: true, // 流体高度
  showOrdinal: false, // 是否显示序号,
  count: "total",
  resultListName: "records",
  params: [
    {
      prop: "supplierUserApplyNo",
      label: "申请单号",
      isSlot: true,
      width: "132px",
    },
    {
      prop: "username",
      label: "申请人账号",
    },
    {
      prop: "name",
      label: "申请人名称",
    },
    {
      prop: "phone",
      label: "激活账号",
    },
    {
      prop: "ssoSupplierUserName",
      label: "激活账号名称",
    },
    {
      prop: "remark",
      label: "申请备注",
      showOverflowTooltip: true,
    },
    {
      prop: "supplierUserApplyFiles",
      label: "证明材料",
      isSlot: true,
      showOverflowTooltip: true,
    },
    {
      prop: "createTime",
      label: "申请时间",
    },
    {
      prop: "ssoSupplierUserApplyStatusStr",
      label: "状态",
      width: "100px",
    },
  ],
  extra: {},
};

export const userTagTableConfig = {
  searchUrl: "/front/oms/userAbilityApply/queryPage", // 搜索接口
  searchMethod: "POST", // 接口请求方式
  needPagination: true, // 是否需要分页
  fluidHeight: true, // 流体高度
  showOrdinal: false, // 是否显示序号,
  count: "total",
  resultListName: "records",
  params: [
    {
      prop: "supplierUserAbilityApplyNo",
      label: "申请单号",
      isSlot: true,
      width: "132px",
    },
    {
      prop: "username",
      label: "申请人账号",
    },
    {
      prop: "createUserName",
      label: "申请人名称",
    },
    {
      prop: "ability3",
      label: "申请标签",
      isSlot: true,
    },
    {
      prop: "remark",
      label: "申请备注",
      showOverflowTooltip: true,
    },
    {
      prop: "proofFiles",
      label: "证明材料",
      isSlot: true,
      showOverflowTooltip: true,
    },
    {
      prop: "createTime",
      label: "申请时间",
      width: "160px",
    },
    {
      prop: "supplierUserAbilityApplyStatusStr",
      label: "状态",
      width: "100px",
    },
  ],
  extra: {},
};

export const userInfoSearchConfig = {
  params: [
    {
      prop: "name",
      label: "人员姓名",
    },
    {
      prop: "username",
      label: "人员账号",
    },
    {
      prop: "userType",
      label: "角色",
      searchType: "select",
      options: [
        {
          label: "管理员",
          value: '1',
        },
        {
          label: "工程师",
          value: '2',
        },
      ],
    },
  ],
};

export const attrSearchConfig = {
  params: [
    {
      prop: "supplierAbilityApplyNo",
      label: "申请单号",
    },
    {
      prop: "username",
      label: "申请人账号",
    },
  ],
};

export const baseSearchConfig = {
  params: [
    {
      prop: "supplierUserAbilityApplyNo",
      label: "申请单号",
    },
    {
      prop: "username",
      label: "申请人账号",
    },
  ],
};